import React, { useEffect, useRef } from 'react'

const AutoFocus = () => {
  const ref = useRef(null)
  useEffect(() => {
    if (!ref.current) return
    const timeoutId = setTimeout(() => {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 250) // Нужно 250 мс чтобы отрисовались данные
    return () => clearTimeout(timeoutId)
  }, [])
  return (
    <span
      ref={ref}
      style={{
        position: 'relative',
        top: -80 // размер заголовка блока для фокуса на заголовке
      }}
    />
  )
}

export default AutoFocus
